import { Injectable } from '@angular/core';
import {RequestService} from './request.service';
import {AbstractControl, AsyncValidatorFn, FormGroup, ValidationErrors} from "@angular/forms";
import {catchError, map, Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserValidatorService {

  constructor(private requestService: RequestService) { }


  phoneServiceExistValidator(requestId: string, fieldKey?: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      let phone = this.cleanPhone(control.value);
      return this.requestService.getUserPhoneExist(phone, requestId, fieldKey).pipe(
        map(resp => {
          return resp.status === 200 ? null : { duplicate: true };
        }),
        catchError(err => {
          if (err.status === 409) {
            return of({ duplicate: true });
          }
          return of({ serverError: true });
        })
      );
    };
  }

  phoneServiceVerification(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      let phone = this.cleanPhone(control.value);
      return this.requestService.getUserPhoneVerification(phone).pipe(
        map(resp => {
          return resp.status === 200 ? null : { invalid: true };
        }),
        catchError(err => {
          if (err.status === 406) {
            return of({ invalid: true });
          }
          return of({ serverError: true });
        })
      );
    };
  }

  emailServiceExistValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) return of(null);
      return this.requestService.getUserEmailExist(control.value).pipe(
        map(resp => {
          return resp.status === 200 ? null : { duplicate: true };
        }),
        catchError(err => {
          if (err.status === 409) {
            return of({ duplicate: true });
          }
          return of({ serverError: true });
        })
      );
    };
  }

  emailServiceStatusValid(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) return of(null);
      return this.requestService.getValidStatusEmail(control.value).pipe(
        map(resp => {
          return resp.status === 200 ? null : { invalid: true };
        }),
        catchError(err => {
          if (err.status === 406) {
            return of({ invalid: true });
          }
          return of({ serverError: true });
        })
      );
    };
  }

  isAllPhoneEquals(form: FormGroup, alternatePhone: string, referralPhone: string) {
    return (control: AbstractControl): ValidationErrors | null => {

      const alternate = form.get(alternatePhone);
      const referral = form.get(referralPhone);

      if (!alternate || !referral) {
        return null;
      }

      const alternateValue = this.cleanPhone(alternate.value);
      const referralValue = this.cleanPhone(referral.value);

      if (referralValue === alternateValue) {
        return { yesEqual: true };
      }

      return null;
    };
  }


  cleanPhone(phone:string){
    return phone?.replace(/^\+\d+\s?/, '')?.replace(/\D/g, '');
  }



}

